export interface Scope {
    id: number;
    name: string;
    selected: boolean;
}

export enum ModeType {
    DEFAULT = "default",
    AVAILABILITY = "availability"
}
export interface ProductAvailability {
  name: string;
  selected: boolean;
  availability: Availability;
}

export interface Availability {
  label: string;
  key: string;
  color: string;
}